import React from "react";

const EmailLogo = ({ ...rest }) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path 
                d="M1.33333 4.66667L6.77661 8.47696C7.21739 8.78551 7.43778 8.93978 7.6775 8.99954C7.88926 9.05232 8.11073 9.05232 8.32249 8.99954C8.56221 8.93978 8.7826 8.78551 9.22338 8.47696L14.6667 4.66667M4.53333 13.3333H11.4667C12.5868 13.3333 13.1468 13.3333 13.5746 13.1153C13.951 12.9236 14.2569 12.6176 14.4487 12.2413C14.6667 11.8135 14.6667 11.2534 14.6667 10.1333V5.86667C14.6667 4.74656 14.6667 4.18651 14.4487 3.75868C14.2569 3.38236 13.951 3.0764 13.5746 2.88465C13.1468 2.66667 12.5868 2.66667 11.4667 2.66667H4.53333C3.41322 2.66667 2.85317 2.66667 2.42535 2.88465C2.04902 3.0764 1.74306 3.38236 1.55132 3.75868C1.33333 4.18651 1.33333 4.74656 1.33333 5.86667V10.1333C1.33333 11.2534 1.33333 11.8135 1.55132 12.2413C1.74306 12.6176 2.04902 12.9236 2.42535 13.1153C2.85317 13.3333 3.41322 13.3333 4.53333 13.3333Z" 
                stroke="#9195A9" 
                strokeWidth="1.33" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
            />
        </svg>
    );
};

export default EmailLogo;
